import SharedButton from '@/global/Button/Button';
import { useResendConfirmationEmail } from '@/utils/resendConfirmationEmail';

type ResendConfirmationEmailButtonProps = {
  email: string;
  className?: string;
};

function ResendConfirmationEmailButton({ email, className }: ResendConfirmationEmailButtonProps) {
  const { isLoading, feedback, resend } = useResendConfirmationEmail(email);

  return (
    <div className={className}>
      <SharedButton
        type="button"
        variant="secondaryOutline"
        size="sm"
        onClick={resend}
        disabled={isLoading || !email.trim()}
      >
        {isLoading ? 'Sending...' : 'Resend confirmation email'}
      </SharedButton>
      {feedback && (
        <p
          className={feedback.type === 'success' ? 'form-success mt-2' : 'form-error mt-2'}
          style={{ fontSize: '12px' }}
        >
          {feedback.message}
        </p>
      )}
    </div>
  );
}

export default ResendConfirmationEmailButton;
